import React from "react";
import { twClassNames } from "../helpers/twClassNames";

export type ChipColor =
    | "brand"
    | "purple"
    | "gray"
    | "white"
    | "green"
    | "yellow"
    | "red"
    | "pink"
    | "aqua"
    | "blue"
    | "sky"
    | "dark"
    | "primary";

export type ChipProps = {
    type?: "text" | "number" | "square" | "stepper" | "classChip";
    color?: ChipColor;
    className?: string;
    title?: string;
    size?: string;
    children: React.ReactNode;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    customColor?: boolean;
    style?: React.CSSProperties;
};

export const Chip = React.forwardRef<HTMLDivElement, ChipProps>(
    (
        {
            type = "text",
            color = "gray",
            className = "",
            children,
            onClick = () => {},
            size = "",
            customColor = false,
            title,
            style
        },
        ref
    ) => {
        return (
            <div
                ref={ref}
                className={twClassNames("chip", type, !customColor && color, className, size)}
                onClick={onClick}
                style={style}
                title={title}
            >
                {children}
            </div>
        );
    }
);

Chip.displayName = "Chip";
